import { UiService } from '../UiService';

export default class PrivacyPriorityScreen {
    /**
     * PrivacyPriorityScreen constructor
     * @param {UiService} uiService
     */
    constructor(uiService) {
        this.uiService = uiService;
    }

    display() {
        return new Promise((resolve) => {
            this.uiService.switchScreen('#privacy-priority');
            document.getElementById('privacy-priority-got-it').addEventListener('click', (event) => {
                event.preventDefault();

                resolve(true);
            });
        });
    }
}
